export default {"src":"/_next/static/media/AAPL.b7b81a2d.svg","height":18,"width":18};